import React, { FC } from 'react';
import { useT } from 'hooks';
import * as S from './styled';

export const PromocodePopup: FC = () => {
	const { T } = useT();
	return (
		<S.Container>
			<S.Popup>
				<S.Icon></S.Icon>
				<S.Text>{T('promocode_success')}</S.Text>
			</S.Popup>
		</S.Container>
	);
};
